export default {
  title: 'title',
  description: 'description',
  url: 'url',
  color: 'color',
  timestamp: 'timestamp',
  footerIconURL: 'footerIconURL',
  footerText: 'footerText',
  authorIconURL: 'authorIconURL',
  authorName: 'authorName',
  authorURL: 'authorURL',
  thumbnailURL: 'thumbnailURL',
  imageURL: 'imageURL'
}
